export default "__VITE_ASSET__4PBG6gfh__"